module.exports = __webpack_public_path__ + "mastodon-getting-started-758db9bb72f30f65b07bb7b64f24ea83.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mastodon-getting-started.png
// module id = 193
// module chunks = 65